import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["input", "hiddenInput"]

  async initialize() {
    const intlTelInput = (await import("intl-tel-input/intlTelInputWithUtils")).default
    if (this.hasInputTarget) {
      this.iti = intlTelInput(this.inputTarget, {
        formatOnDisplay: true,
        separateDialCode: true,
        initialCountry: "US",
        customContainer: "c-intl-tel-input"
      })
    }
  }

  submit(event) {
    event.preventDefault()

    if (this.hasInputTarget) {
      this.hiddenInputTarget.value = this.iti.getNumber()
      this.sendValidationEventHandler()
    }
  }

  sendValidationEventHandler() {
    this.element.dispatchEvent(new CustomEvent("validated-phone.validated"))
  }
}
